'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'citrus-slice';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e2f5';
var svgPathData = 'M464 208c0 141.4-114.6 256-256 256-49.2 0-95.2-13.9-134.2-37.9L101 398.9c33.3 21 72.7 33.1 115 33.1 119.3 0 216-96.7 216-216 0-42.3-12.1-81.7-33.1-115l27.2-27.2c24.1 39 37.9 85 37.9 134.2zM63.3 368.7c-17.8 17.8-38.5 38.5-62.1 62.1 11.8 11 24.5 21 37.9 30 48.3 32.3 106.4 51.2 168.9 51.2 167.9 0 304-136.1 304-304 0-62.5-18.9-120.6-51.2-168.9-9-13.4-19-26.1-30-37.9-416.4 416.4-322.9 322.9-367.5 367.5zM224 288c11.3 0 22.5-3 32.5-8.9l66.4 66.4c-27.1 22.4-61.4 36.5-98.9 38.2l0-95.8zm55.1-31.5c5.9-10 8.9-21.3 8.9-32.5l95.8 0c-1.8 37.5-15.8 71.8-38.2 98.9l-66.4-66.4zM136.1 363.8l55.9-55.9 0 74.4c-20-2.9-38.9-9.2-55.9-18.5zM307.9 192l55.9-55.9c9.3 17.1 15.6 35.9 18.5 55.9l-74.4 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCitrusSlice = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;